import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../../services/service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-skor',
  templateUrl: './skor.component.html',
  styleUrls: ['./skor.component.css']
})
export class SkorComponent implements OnInit {

  extra:any;
  setting:any;

  constructor(private router:Router, private service:ServiceService) {
    this.extra = this.service.getExtra();
    this.setting = this.service.getSetting();
    if(this.extra.skor == null){
      this.router.navigate(['/soal']);
    }
  }

  ngOnInit() {
  }

  logout(){
    this.router.navigate(['/logout']);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/skor/skor.component.ts